import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Projects from '../components/Projects';
import Contact from '../components/Contact';

const HomePage = () => {
    return (
        <>
            <Hero />
            <About />
            <Services />
            <Projects />
            <Contact />
        </>
    );
};

export default HomePage;

